import { render, staticRenderFns } from "./ExtraProducts.vue?vue&type=template&id=3309f1ea&"
import script from "./ExtraProducts.vue?vue&type=script&lang=js&"
export * from "./ExtraProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports